<script>
  import Redeem from '@/components/sections/Redeem.vue';

  export default {
    name: 'PurchaseTab',

    components: {
      Redeem,
    },

    computed: {
      currencies() {
        return this.$store.state.cashierCurrencies;
      },
    },
  };
</script>

<template>
  <div class="withdraw-tab">
    <Redeem :currencies="currencies" />
  </div>
</template>

<style lang="scss" scoped></style>
